import DesCreateTeamSubPanelViewModel from 'viewmodel/DesCreateTeamSubPanelViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCreateTeamSubPanel extends DesBaseCatalogAcc {
    constructor() {
        super(DesCreateTeamSubPanelViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }
    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'email-template-id', 'email-template-params', 'collaborationspaceid', 'locale'];
    }

}
if (!window.customElements.get('des-create-team-sub-panel')) {
    window.customElements.define('des-create-team-sub-panel', DesCreateTeamSubPanel);
}
